import { render, staticRenderFns } from "./best-cab-service-goa.vue?vue&type=template&id=d4fd77d4&scoped=true"
import script from "./best-cab-service-goa.vue?vue&type=script&lang=js"
export * from "./best-cab-service-goa.vue?vue&type=script&lang=js"
import style0 from "./best-cab-service-goa.vue?vue&type=style&index=0&id=d4fd77d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fd77d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
